import React, { useEffect } from 'react';
import Head from 'next/head';
import { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import { ApolloProvider } from '@apollo/client';
import { initializeGraphqlClient } from 'src/client/graphql/client';
import { GlobalContextProvider } from 'client/contexts/global';
import { ChatContextProvider } from 'src/client/contexts/chat';
import 'swiper/swiper.scss';
import 'src/client/styles/tailwind.css';
import 'src/client/styles/swiper.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'src/client/styles/global.css';
import { Snackbar } from 'src/client/components/common/SnackBar/Snackbar';
import { GTMPageView } from 'src/utils/gtm';

type UcarePageProps = {
  token?: string;
};

const App = ({ Component, pageProps }: AppProps<UcarePageProps>) => {
  const graphqlClient = initializeGraphqlClient();
  const router = useRouter();

  // Initiate GTM
  useEffect(() => {
    const handleRouteChange = (url: string) => GTMPageView(url);
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover" />
      </Head>
      <ApolloProvider client={graphqlClient}>
        <GlobalContextProvider token={pageProps.token}>
          <ChatContextProvider>
            <Snackbar>
              <Component {...pageProps} />
            </Snackbar>
          </ChatContextProvider>
        </GlobalContextProvider>
      </ApolloProvider>
    </>
  );
};

export default App;
